'use strict';
import $ from 'jquery';

export default class SubscribeShortcode {
  static init() {
    $('.block-subscribe').each((index, el) => {
      new SubscribeShortcode($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    this.el.find('form').on('submitSuccess', this.onFormSubmitted.bind(this));
  }

  onFormSubmitted() {
    console.log('subscribe form submitted!');
    this.el.find('*:not(.block-subscribe-thank-you').hide();
    this.el.find('.block-subscribe-thank-you').show();
  }
}
